<cc-dashboard-page-container>
  <ng-container title>
    <span>{{
      'spot-configuration.spot-configuration-identifier.DETAILS_TITLE'
        | transloco
    }}</span>
  </ng-container>

  <cc-table-preview page-content>
    <cc-table-container [isLoading]="isLoading$ | async">
      <div table-buttons class="flex flex-col sm:flex-row">
        <cc-add-action-button
          [routerLink]="['preview', 'new']"
        ></cc-add-action-button>
      </div>

      <bo-mat-table
        #table
        matSort
        [data]="spotIdentifiers$ | async"
        (matSortChange)="onSort($event)"
        (pageChange)="setPage($event)"
      >
        <ng-container matColumnDef="identifier">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{
              'spot-configuration.spot-configuration-identifier.fields.IDENTIFIER'
                | transloco
            }}
          </th>
          <td mat-cell *matCellDef="let element">
            <!-- <ng-katex [equation]="element.identifier"></ng-katex> -->
            <div [innerHTML]="element.identifier | katex"></div>
          </td>
        </ng-container>

        <ng-container matColumnDef="hour">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{
              'spot-configuration.spot-configuration-identifier.fields.HOUR'
                | transloco
            }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.hour }}
          </td>
        </ng-container>
      </bo-mat-table>
    </cc-table-container>
  </cc-table-preview>
</cc-dashboard-page-container>
